import { render } from "./EventList.vue?vue&type=template&id=490fad66"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"
script.render = render

export default script